import { type AlgoliaRecord, algoliaRecordAccessorIsSaeOffer } from '../algolia'
import { type TENANT, TENANT as TENANT_VALUE } from '../tenant'

export const productIsBelgian1P = (
  tenant: TENANT,
  product: AlgoliaRecord,
): boolean =>
  tenant === TENANT_VALUE.BE &&
  (!product.marketplace || algoliaRecordAccessorIsSaeOffer(product))
